<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic
    include /@ibkr/lib.common/src/icon/arrow

    ib-progress-linear(class="_row grow", :class="{ signedin: signedIn }", :show="loading", blocking)
        ib-col(class="flex")
            ib-row
                ib-col(class="flex-fixed border-bottom border-xs insetx-16")
                    div(class="fs7")
                        span(v-if="cusipId && cusipVal", class="results-shown")
                            | {{ $t('showing') }} {{ $num.int(results.length) }} {{ $t('of') + ' ' +
                            |  $num.int(results.length) }}
                        span(v-else-if="conids.length <= results.length", class="results-shown")
                            | {{ $t('showing') }} {{ $num.int(results.length) }} {{ $t('of') + ' ' +
                            |  $num.int(total) }}
                        span(v-else, class="results-shown")
                            | {{ $t('showing') }} {{ results.length ? $num.int((MAX_ROWS * (curPage - 1) + 1)) : 0 }}
                            | {{ $t('to') }} {{ $num.int(MAX_ROWS * (curPage - 1) + results.length) }}
                            | {{ $t('of') + ' ' + $num.int(total) }}
                    ib-paginate(v-if="!loading", v-model="curPage", :stride="5", :size="5", :max="maxPage")
            ib-table-basic(
                row,
                class="grow fs7 fg70 shrink",
                :data="results",
                spacing="huge",
                ref="table",
                @sort="sort"
            )
                ib-table-col(:width="$media.m ? '36ch' : '20ch'", sticky) {{ $t('product') }}
                ib-table-col(width="12ch", numeric) {{ $t('bid_yield') }}
                ib-table-col(width="12ch", numeric) {{ $t('bid_price_size') }}
                ib-table-col(width="12ch", numeric, sort, descending, name="askYield") {{ $t('ask_yield') }}
                ib-table-col(width="12ch", numeric) {{ $t('ask_price_size') }}
                ib-table-col(v-if="isMuni" width="6ch") {{ $t('state') }}
                ib-table-col(width="12ch", numeric, sort, descending, ascending, name="Maturity") {{ $t('maturity') }}
                ib-table-col(width="8ch") {{ $t('callable') }}
                ib-table-col(v-if="!signedIn", width="12ch") {{ $t('CUSIP') }}
                ib-table-col(v-if="signedIn", width="14ch") {{ $t('CUSIP') }}
                ib-table-col(v-if="!signedIn", width="12ch") {{ $t('moodys') }}
                ib-table-col(v-if="signedIn", width="8ch") {{ $t('moodys') }}
                ib-table-col(v-if="!signedIn", width="12ch") {{ $t('sp_ratings') }}
                ib-table-col(v-if="signedIn", width="8ch") {{ $t('sp_ratings') }}
                ib-table-col(v-if="inCP", width="8ch")
                p(slot="empty", v-if="loading") {{ $t('loading') }} ...
                p(slot="empty", v-else) {{ $t('no_results') }} ...
                template(slot="body" slot-scope="row")
                    td(:name="row.conid", class="ellipsis")
                        ib-button(
                            v-if="isPortal || typeof accountManage !== 'undefined'",
                            :title="row.fullName",
                            class="link bold inset-0",
                            @click="toQd(row)"
                        ) {{ getSafeValue(row.fullName) }}
                        span(@click="getLoginToView", v-else)
                            span(:title="row.fullName", class="bold") {{ getSafeValue(row.fullName) }}
                        br
                        span(class="fs7 fg50 clipped", :title="row.companyName") {{ getSafeValue(row.companyName) }}
                    td(@click="getLoginToView")
                        span(class="bold") {{ getSafeValue(row.bidYield) }}
                    td(@click="getLoginToView")
                        span(v-if="row.bid") &nbsp;{{ $num.fixed4(row.bid) }}
                        br
                        span(v-if="row.bidSize", class="fs7 fg50") &nbsp;x&nbsp;{{ getSafeAskBid(row.bidSize) }}
                    td(@click="getLoginToView")
                        span(class="bold") {{ getSafeValue(row.askYield) }}
                    td(@click="getLoginToView")
                        span(v-if="retry > 0 || row.ask")
                            span(v-if="row.ask") &nbsp;{{ $num.fixed4(row.ask) }}
                        span(v-else-if="row.last", title="C=Closing") &nbsp;({{ row.last }}*)
                        br
                        span(v-if="row.askSize", class="fs7 fg50") &nbsp;x&nbsp;{{ getSafeAskBid(row.askSize) }}
                    td(v-if="isMuni", @click="getLoginToView", :title="row.state") {{ row.state }}
                    td(@click="getLoginToView")
                        span {{ row.maturityDate | dateFormat }}
                    td(class="text-center", @click="getLoginToView")
                        span(v-if="row.isCallable === 'Y'", class="fg-positive")
                            +icon-basic-checkmark
                        span(v-else-if="row.isCallable === 'N'", class="fg50")
                            +icon-basic-close
                    td(@click="getLoginToView")
                        span(v-if="!signedIn && !cusipVal", class="blue") {{ $t('login_to_view') }}
                        span(v-else-if="cusipVal") {{ cusipVal }}
                        span(v-else) {{ row.cusip }}
                    td(@click="getLoginToView")
                        span(v-if="!signedIn", class="blue") {{ $t('login_to_view') }}
                        span(v-else) {{ row.moodys }}
                    td(@click="getLoginToView")
                        span(v-if="!signedIn", class="blue") {{ $t('login_to_view') }}
                        span(v-else) {{ row.sp }}
                    td(v-if="inCP", class="insetx-0 nopad")
                        ib-button(class="link", @click.prevent="trade(row)") {{ $t('trade') }}
        ib-dialog(width="50%", :autoclose="true", v-model="showLoginScreen")
            div(class="inner-modal modal-scroll")
                div(class="add-info")
                    h3 {{ $t('bond_search') }}
                    a(@click="closeModal")
                        span
                            +icon-basic-cancel
                h5 {{ $t('login_portal_view_more') }}
                p(class="text-right inset-8")
                    ib-button(class="bg-accent _btn xs", @click.prevent="addFilters") {{ $t('have_existing_account') }}
                h5 {{ $t('dont_have_account') }}
                p(class="text-right inset-8")
                    a(class="bg-accent _btn xs", href="https://www.interactivebrokers.com/en/index.php?f=4695") {{ $t('open_an_ibaccount') }}
</template>

<script>
    import { mapGetters } from 'vuex'
    import api from '../api/'
    import mxGb from '../mixin/mixin-global'

    const MAX_ROWS = 50;
    const sortColumns = {
        "Maturity": {
            aesc: "NEAR_MATURITY_DATE",
            desc: "FAR_MATURITY_DATE"
       },
        "askYield": {
            aesc: "NO_SUPPORT",
            desc: "HIGH_BOND_ASK_YIELD_ALL"
       }
    };
    const sso = 'https://www.interactivebrokers.com/sso/Login?action=BONDSCANNER';

    export default {
        name: 'SearchResults',
        mixins: [mxGb],

        created() {
            this.$overlay = window.Vue.prototype.$overlay;
            this.checkSignedIn();
        },

        props: {
            scannerFilters: Object,
            isMuni: {
                type: Boolean,
                default: false
            },
            cusipId: String,
            cusipVal: String,
            curTabVal: String
        },

        data() {
           return {
                accountManage: window.AM_SESSION_ID,
                conids:[],
                curConids: [],
                count: 0,
                curPage: 1,
                signedIn: false,
                maxPage: 1,
                mdFields: [31, 86, 84, 85, 88, 7699, 7720, 7051],
                loading: false,
                retry: 5,
                results: [],
                total: 0,
                position: undefined,
                page: 'next',
                MAX_ROWS: MAX_ROWS,
                marketDataTimeout: undefined,
                query: '',
                showLoginScreen: false
             }
        },
        filters: {
            stringFormat(val) {
                return val ? val : '-';
            },
            dateFormat(val) {
                const Y = val && val.substring(0,4);
                const D = val && val.substring(6,8);
                const M = val && val.substring(4,6);
                if (Y && M && D) {
                    return M + "/" + D + "/" + Y;
                }
                return '-';
            }
        },

        watch: {
            scannerFilters(obj) {
                this.refresh(true);

            },
            curPage: {
                handler: function(newVal, oldVal) {
                    const goal = (newVal - 1) * MAX_ROWS + 1;
                    window.scrollTo(0,0);
                    if (goal > this.conids.length && goal <= this.total) {
                        this.retry = 5;
                        this.search();
                    } else if (newVal !== oldVal) {
                        this.curConids = this.conids.slice(MAX_ROWS * (newVal - 1), MAX_ROWS * newVal);
                        this.loading = true;
                        this.results = [];
                        this.retry = 5;
                        this.getSecdef();
                    }
                }
            }
        },

        mounted() {
            this.refresh(true);
        },

        methods: {
            addFilters() {
                this.query = {...this.scannerFilters};
                delete this.query.filters;
                this.query = new URLSearchParams(this.query).toString();
                let filters = this.scannerFilters.filters;
                const industry = filters.find(obj => obj.code === "industryLike");
                if (industry) { industry.value = industry.value.replace(/#/g, "_") }
                filters = filters.map(filter => `${filter['code']}=${filter['value']}`);
                filters = filters.join('&');
                filters = `${filters}&curTabVal=${this.curTabVal}`;
                if (this.cusipVal) {
                    filters = `${filters}&cusip=${this.cusipVal}&cusipId=${this.cusipId}`;
                }
                filters = filters.replace(/\+/g, "@");
                window.location.href = `${sso}&${this.query}&${filters}`;
            },
            checkScroll() {
                this.$refs.table["$el"]["scrollLeft"] = this.$refs.scrollbar["scrollLeft"];
            },
            checkSignedIn() {
                if (this.isPortal) {
                    this.signedIn = true;
                } else if (typeof accountManage !== 'undefined') {
                    this.signedIn = true;
                    this.$emit('signedIn', this.signedIn);
                } else {
                    api.checkCP()
                        .then(res => {
                            if (res && res["RESULT"] === true) {
                                this.signedIn = true;
                            }
                        })
                        .catch(error => console.log(error))
                }
            },
            closeModal() {
                this.showLoginScreen = false;
                this.showMoreInfo = false;
            },
            getLoginToView() {
               if (!this.signedIn) {
                    this.showLoginScreen = true;
               }
            },
            getMDSnapshot() {
                if (this.marketDataTimeout) {
                    clearTimeout(this.marketDataTimeout);
                    this.marketDataTimeout = undefined;
                }
                const ids = this.curConids.join(',');
                if (!ids) {
                    return;
                }
                api.getSnapshot({
                    conids: ids,
                    fields: this.mdFields
                })
                .then((res) => {
                    res.forEach((item) => {
                        if (item['7051'] || item['86'] || item['84'] || item['7699'] || item['7720']) {
                            for(let i = 0; i < this.results.length; i++) {
                                const obj = this.results[i];
                                if (obj.conid == item.conid) {
                                    const update = {
                                        last: item['31'],
                                        askSize: item['85'],
                                        ask: item['86'],
                                        bid: item['84'],
                                        bidSize: item['88'],
                                        askYield: item['7720'],
                                        bidYield: item['7699'],
                                        companyName: item['7051']
                                    };
                                    Vue.set(this.results, i, { ...obj, ...update });
                                    break;
                                }
                            }
                        }
                        //remove conids which have data already, save traffic
                        if (item['86'] && item['84'] && item['7720'] && item['7699']) {
                            this.curConids.splice(this.curConids.indexOf(item.conid), 1);
                        }
                    });
                    if (this.retry-- > 0) {
                        this.marketDataTimeout = setTimeout(() => this.getMDSnapshot(), 2000);
                    }
                })
            },
            getSafeValue(val) {
                const ret = this.retry > 0 ? '' : '\u2014';
                return val ? val : ret;
            },
            getSafeAskBid(val) {
                const rets = this.retry > 0 ? '' : '\u2014';
                val.includes("20ac") ? val = "EUR" + val.substring(5, val.length) : val;
                val.includes("00a") ? val = "GBP" + val.substring(5, val.length) : val;
                return val ? val : rets;
            },
            getSecdef() {
                if (this.curConids.length === 0) {
                    return;
                }
                //instaniate results array
                this.results = this.curConids.map(e => {
                    return { conid: e }
                });
                this.marketDataTimeout = setTimeout(() => this.getMDSnapshot(), 2000);
                this.sendSecdef(this.curConids);
            },
            handleContracts(res) {
                if (this.cusipId && this.cusipId != '' && this.cusipVal != '') {
                    this.conids.push(parseInt(this.cusipId));
                } else {
                    const contracts = res.Contracts && res.Contracts["Contract"];
                    contracts.forEach((contract) => {
                        this.conids.push(parseInt(contract["contractID"]));
                    });
                }
                if (this.conids.length > MAX_ROWS) {
                    this.curConids = this.conids.slice(MAX_ROWS * (this.curPage - 1), MAX_ROWS * this.curPage);
                    this.maxPage = Math.ceil(this.total / MAX_ROWS) ;
                } else {
                    this.curConids = this.conids.slice();
                }
                this.getSecdef();
            },
            refresh(isRetry) {
                this.results = [];
                this.position = undefined;
                this.curPage = 1;
                this.maxPage = 1;
                this.total = 0;
                this.conids = [];
                this.curConids = [];
                this.retry = isRetry ? 5 : 0;
                window.scrollTo(0,0);
                this.search();
            },
            search() {
                this.loading = true;
                this.scannerFilters.page = this.page;
                this.scannerFilters.position = this.position;
                if (this.cusipId && this.cusipId != '' && this.cusipVal != '') {
                    if (this.cusipId == 0) {
                        this.$alert(this.$t('zero_results'));
                        this.loading = false;
                        this.maxPage = 1;
                        return;
                    }
                    this.handleContracts(this.cusipId);
                } else {
                    api.searchBonds(this.scannerFilters)
                        .then((res)=> {
                            this.total = res.total;
                            this.position = res.position;
                            if (res.total === undefined && res.warningText) {
                                /*
                                * This is a special case which only happened after-hour and only for muni bonds,
                                * there is no total returned, we need to extract it from warningText.
                                */
                                const nums = res.warningText.match(/\d+/g);
                                if (nums.length === 2) {
                                    this.total = nums[1];
                                    this.handleContracts(res);
                                } else if (nums.length > 0) {
                                    this.total = nums[0];
                                    this.handleContracts(res);
                                } else {
                                    this.$alert(this.$t('zero_results'));
                                }
                            } else if (res.errorText) {
                                this.$alert(res.errorText);
                                this.loading = false;
                            } else if (res.total === 1) {
                                //here is a special case, Contract is returned as an object instead of an array
                                const contract = res.Contracts && res.Contracts["Contract"];
                                this.conids.push(parseInt(contract.contractID));
                                this.curConids = this.conids.slice();
                                this.getSecdef();
                            } else if (res.total > 1) {
                                this.handleContracts(res);
                            } else {
                                this.$alert(this.$t('zero_results'));
                                this.loading = false;
                                this.maxPage = 1;
                                return;
                            }
                        })
                        .catch(error => {
                            console.log(error);
                            this.loading = false;
                            this.$alert(this.$t('not_available_try_again'));
                        })
                }
            },
            sendSecdef(ids) {
                api.getSecdef(
                {"conids": ids }, this.signedIn
                ).then((res) => {
                    res.secdef.forEach((item) => {
                        for(let i = 0; i < this.results.length; i++) {
                            const obj = this.results[i];
                            if (obj.conid == item.conid) {
                                const bond = item['bond'] || {};
                                const update = {
                                    fullName: item['fullName'],
                                    maturityDate: bond['maturityDate'],
                                    isCallable: bond['isCallable']
                                };
                                if (this.signedIn) {
                                    update['cusip'] = bond && bond['si'] 
                                     && bond['si'][0]['is'] === "CUSIP" ? bond['si'][0]['id']  :  '\u2014';
                                    const rating = bond && bond['issueRating'];
                                    if (rating) {
                                        if (rating.length === 0) {
                                            update['moodys'] = '\u2014';
                                            update['sp'] = '\u2014';
                                        }
                                        if (rating[0] && rating[0]['agency'] === 'TRACE') {
                                            update['moodys'] = '\u2014';
                                            update['sp'] = '\u2014';
                                        }
                                        if (rating[0] && rating[0]['agency'] === 'MOODY') {
                                            update['moodys'] = rating[0]['ratingValue'];
                                        }
                                        if (rating[0] && rating[0]['agency'] === 'SP') {
                                            update['moodys'] = '\u2014';
                                            update['sp'] = rating[0]['ratingValue'];
                                        }
                                        if (rating[1] && rating[1]['agency'] === 'MOODY') {
                                            update['moodys'] = rating[1]['ratingValue'];
                                        }
                                        if (rating[1] && rating[1]['agency'] === 'SP') {
                                            update['sp'] = rating[1]['ratingValue'];
                                        }
                                        if (rating[0] && rating[0]['agency'] === 'MOODY' && !rating[1]) {
                                            update['sp'] = '\u2014';
                                        }
                                        if (rating[0] && rating[0]['agency'] === 'MOODY' && rating[1] && rating[1]['agency'] !== 'SP') {
                                            update['sp'] = '\u2014';
                                        }
                                    } else {
                                        update['moodys'] = '\u2014';
                                        update['sp'] = '\u2014';
                                    }
                                }
                                if (this.isMuni) {
                                    update['state'] = bond['taxState'];
                                }
                                Vue.set(this.results, i, { ...obj, ...update });
                                break;
                            }
                        }
                    });

                    this.loading = false;
                }).catch(error => {
                    console.error('secdef error: ', error);
                    this.$alert(this.$t('not_available_try_again'));
                    this.loading = false;
                })
            },
            sort(obj) {
                //This is the entry when component is created
                if (this.loading || !obj) {
                    return;
                }
                const col = obj.name;
                const dir = obj.dir > 0 ? 'aesc' : 'desc';
                const scanCode = sortColumns[col] && sortColumns[col][dir];
                if (scanCode === 'NO_SUPPORT') {
                    this.$alert(this.$t('only_high_low'));
                    return;
                }
                this.scannerFilters.scanCode = scanCode;
                this.refresh(true);
            },
            trade(row) {
                window.onebar.toggleQuickTradeV2({ conid: row.conid, referrer: 'BOND-SCANNER', isBuy: true });
            },
            toQd(row) {
                this.$router.push({
                    path: '/quote',
                    query: {
                        conid: row.conid
                    }
                });
            }
        }
 }
</script>

<style lang="less">
    .blue {
        color: #0B56BF;
    }

    .inner-modal {
        width: 100%;
        border-top: 0.25rem solid #db1222;
        padding: 10px 0;
        &.modal-scroll {
            padding: 10px;
        }
        .add-info {
            a {
                float: right;
                padding-right: 10px;
                cursor: pointer;
                span {
                    color: #000;
                    margin-right: 10px;
                }
            }
            h3 {
                display: inline-block;
                padding: 5px 10px 10px 10px;
            }
        }
        .more-info {
            padding: 30px 10px;
        }
        .logins {
            float: right;
            padding: 10px;
            a {
                background-color: #db1222;
                padding: 7px 10px;
                margin-right: 10px;
            }
        }
    }


    .info {
        padding: 0 0.6rem;
        margin-right: 1rem;
        span {
            font-size: 0.5rem;
            margin-left: 0.5rem;
        }
    }

</style>
